import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import './assets/base.css'

import axios from 'axios'

// ────────────────────────────────────────────────
// Axios ni global sozlaymiz (har bir so'rovga token qo'shish)
// ────────────────────────────────────────────────

const BASE_URL = 'http://127.0.0.1:8000'   // o'zingizning backend URL'ingizga o'zgartiring

axios.defaults.baseURL = BASE_URL
axios.defaults.timeout = 15000
axios.defaults.headers.common['Content-Type'] = 'application/json'

// Har bir so'rov oldidan tokenni qo'shish
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken')
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    return config
  },
  error => {
    // so'rov yaratishda xato bo'lsa
    return Promise.reject(error)
  }
)

// Ixtiyoriy: javobda 401 bo'lsa log qilish yoki keyinchalik refresh qilish uchun tayyor joy
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      console.warn('401 Unauthorized → token eskirgan yoki mavjud emas')
      // Bu yerga keyinchalik refresh token logikasini qo'shishingiz mumkin
      // Hozircha faqat console chiqarib qo'yamiz
    }
    return Promise.reject(error)
  }
)

// ────────────────────────────────────────────────
// Vue ilovasini yaratish
// ────────────────────────────────────────────────

const app = createApp(App)

app.use(store)
app.use(router)
app.use(Antd)

// axios ni global property sifatida qo'shamiz (ixtiyoriy, lekin qulay)
app.config.globalProperties.$axios = axios
// Endi har qanday komponentda this.$axios ishlatish mumkin

app.mount('#app')